import { CToast, CToastBody, CToastHeader, CToaster } from '@coreui/react'
import { useEffect, useRef, useState } from 'react'

// Toast de erro de autenticação disparado pelo _axios (evento
// AUTH_ERROR_EVENT): 401 = sessão expirada/sem login (o _axios desloga logo
// em seguida), 403 = logado mas sem permissão pra essa ação. Antes o 401
// deslogava e recarregava a página sem dizer nada — e com as rotas de
// escrita de escola exigindo token (schoolRoutes.js), salvar podia
// simplesmente "não acontecer".
export const AUTH_ERROR_EVENT = 'console:auth-error'

const MESSAGES = {
  401: {
    title: 'Sessão expirada',
    body: 'Não foi possível salvar: sua sessão expirou. Você vai ser levado para o login em instantes; entre de novo e refaça a alteração.',
  },
  403: {
    title: 'Sem permissão',
    body: 'Sua conta não tem permissão para essa ação. Nada foi salvo.',
  },
}

export default function AuthErrorToaster() {
  const [toast, addToast] = useState(0)
  const toaster = useRef()

  useEffect(() => {
    const onError = (e) => {
      const msg = MESSAGES[e.detail && e.detail.status] || MESSAGES[401]
      addToast(
        <CToast autohide={false} visible>
          <CToastHeader closeButton>
            <svg className="rounded me-2" width="20" height="20" xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="xMidYMid slice" focusable="false" role="img">
              <rect width="100%" height="100%" fill="#dc3545"></rect>
            </svg>
            <div className="fw-bold me-auto">{msg.title}</div>
          </CToastHeader>
          <CToastBody>{msg.body}</CToastBody>
        </CToast>,
      )
    }
    window.addEventListener(AUTH_ERROR_EVENT, onError)
    return () => window.removeEventListener(AUTH_ERROR_EVENT, onError)
  }, [])

  return <CToaster ref={toaster} push={toast} placement="top-end" />
}
